import { createDecorator } from '../../instantiation/common/instantiation.js';
const IHoverService = ( createDecorator('hoverService'));
export { IHoverService };
